export default (id) => ({
  isLoading: false,
  id: id,
  setLoading(value) {
    this.isLoading = value;
  },
  trigger: {
    ["@submission-started.window"](e) {
      if (e.detail == this.id) {
        this.setLoading(true);
      }
    },
    ["@submission-cancelled.window"](e) {
      if (e.detail == this.id) {
        this.setLoading(false);
      }
    }
  }
});
